import {
  GET_ADMIN_USER_ROLES,
  GET_ADMIN_USER_ROLES_SUCCESS,
  GET_ADMIN_USER_ROLES_ERROR,
  CREATE_ADMIN_USER_ROLE,
  CREATE_ADMIN_USER_ROLE_SUCCESS,
  CREATE_ADMIN_USER_ROLE_ERROR,
  UPDATE_ADMIN_USER_ROLE,
  UPDATE_ADMIN_USER_ROLE_SUCCESS,
  UPDATE_ADMIN_USER_ROLE_ERROR,
  DELETE_ADMIN_USER_ROLE,
  DELETE_ADMIN_USER_ROLE_SUCCESS,
  DELETE_ADMIN_USER_ROLE_ERROR,
  RESET_LAST_COMPLETED_ACTION_OF_ADMIN_USER_ROLES,
  ADD_NOTIFICATION_TEMPLATE_TO_ADMIN_ROLE,
  ADD_NOTIFICATION_TEMPLATE_TO_ADMIN_ROLE_SUCCESS,
  ADD_NOTIFICATION_TEMPLATE_TO_ADMIN_ROLE_ERROR
} from "./actionTypes"

const initialState = {
  error: null,
  admin_user_roles: [],
  loading: false,
  lastCompletedAction: null,
  last_admin_role_id: null,
}

const AdminUserRoles = (state = initialState, action) => {
  switch (action.type) {
    case GET_ADMIN_USER_ROLES:
      return {
        ...state,
        loading: true
      }

    case GET_ADMIN_USER_ROLES_SUCCESS:
      return {
        ...state,
        admin_user_roles: action.payload,
        loading: false,
        lastCompletedAction: null
      }

    case GET_ADMIN_USER_ROLES_ERROR:
      return {
        ...state,
        error: action.payload,
        loading: false
      }

    case CREATE_ADMIN_USER_ROLE:
      return {
        ...state,
        loading: true
      }

    case CREATE_ADMIN_USER_ROLE_SUCCESS:
      return {
        ...state,
        admin_user_roles: [...state.admin_user_roles, action.payload],
        loading: false,
        lastCompletedAction: action.type,
        last_admin_role_id: action.payload.id
      }

    case CREATE_ADMIN_USER_ROLE_ERROR:
      return {
        ...state,
        error: action.payload,
        loading: false,
        lastCompletedAction: action.type
      }

    case UPDATE_ADMIN_USER_ROLE:
      return {
        ...state,
        loading: true
      }

    case UPDATE_ADMIN_USER_ROLE_SUCCESS:
      return {
        ...state,
        admin_user_roles: state.admin_user_roles.map((single_ad_role) => (single_ad_role.id == action.payload.id
          ? {single_ad_role, ...action.payload }
          : single_ad_role)),
        loading: false,
        lastCompletedAction: action.type,
        last_admin_role_id: action.payload.id
      }

    case UPDATE_ADMIN_USER_ROLE_ERROR:
      return {
        ...state,
        error: action.payload,
        loading: false
      }

    case DELETE_ADMIN_USER_ROLE:
      return {
        ...state,
        loading: true
      }

    case DELETE_ADMIN_USER_ROLE_SUCCESS:
      return {
        ...state,
        admin_user_roles: state.admin_user_roles.filter(ad => ad.id != action.payload.id),
        loading: false
      }

    case DELETE_ADMIN_USER_ROLE_ERROR:
      return {
        ...state,
        error: action.payload,
        loading: false
      }
    case RESET_LAST_COMPLETED_ACTION_OF_ADMIN_USER_ROLES:
      return {
        ...state,
        lastCompletedAction: null
      }
    case ADD_NOTIFICATION_TEMPLATE_TO_ADMIN_ROLE:
      return {
        ...state,
      }
    case ADD_NOTIFICATION_TEMPLATE_TO_ADMIN_ROLE_SUCCESS:
      return {
        ...state,
      }
    case ADD_NOTIFICATION_TEMPLATE_TO_ADMIN_ROLE_ERROR:
      return {
        ...state,
      }
    default:
      return state
  }
}

export default AdminUserRoles;
